import DownloadIcon from "@mui/icons-material/Download";
import Link from "@mui/material/Link";
import NextLink from "next/link";

export default function LinkStyled({ variant, href, label, icon, ...props }) {
  return (
    <Link href={href} variant={variant} component={NextLink}>
      {icon && (
        <DownloadIcon
          fontSize="small"
          sx={{ marginRight: ".25rem", marginBottom: "-.25rem" }}
        />
      )}
      {label}
    </Link>
  );
}
